<template>
  <nv-page header="IOS Rules" data-cy="ios-rules-list">
    <template #toolbar>
      <v-spacer />
      <v-btn class="mr-4" @click="testDialog.show = true">Test Pattern</v-btn>
      <nv-table-search v-model="search" sync />
    </template>

    <template #filters>
      <nv-table-filters
        ref="applied-filters"
        :value="tableFilters"
        @clear="$refs['filter-sheet'].clearFilters()"
      >
        <rules-filter-sheet ref="filter-sheet" @changed="setTableFilters" />
      </nv-table-filters>
    </template>

    <v-data-table
      :headers="headers"
      :items="extendedItems"
      :loading="loading"
      :options.sync="table"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :items-per-page.sync="table.itemsPerPage"
      must-sort
    >
      <template #item="{ item }">
        <tr>
          <td class="text-break py-1">
            <router-link :to="{ name: 'owl.ios.rules.show', params: { ruleId: item.id } }">
              {{ item.pattern }}
            </router-link>
            <div class="text-caption">{{ item.match_type | humanize }}</div>
          </td>
          <td>{{ item.domain }}</td>
          <td class="text-break py-1">{{ item.app_name }}</td>
          <td>{{ item.country | uppercase }}</td>
          <td>
            <router-link
              v-if="item.application"
              :to="{ name: 'owl.applications.show', params: { appId: item.app_dictionary_id } }"
            >
              {{ item.application.name }}
            </router-link>
            <span v-else>Application {{ item.app_dictionary_id }} unavailable</span>
          </td>
          <td>{{ item.status | humanize }}</td>
          <td>
            <updated-details :item="item" />
          </td>
          <td>
            <div class="d-flex">
              <v-btn icon class="mr-2" title="User Agents" @click="openUAForm(item.id)">
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-btn>
              <v-btn v-if="$auth.hasPermissions('ant.discovery')" icon @click="openForm(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <rules-edit-form v-model="form.show" :editing="form.edit" @saved="tableFetch" />
    <ua-dialog v-model="uaDialog.show" :match-id="uaDialog.matchId" />
    <test-rules-patterns v-model="testDialog.show" product="ios" />
  </nv-page>
</template>

<script>
import RulesList from '@/components/cls/RulesList';
import RulesEditForm from '@/components/cls/ios/RulesEditForm';
import RulesFilterSheet from '@/components/cls/ios/RulesFilterSheet';
import UaDialog from '@/components/cls/ios/UaDialog';
import TestRulesPatterns from '@/components/cls/TestRulesPatterns.vue';
import UpdatedDetails from '@/components/cls/UpdatedDetails.vue';

const headers = [
  { text: 'Rule', sortable: false, value: 'pattern' },
  { text: 'Domain', sortable: false, value: 'domain' },
  { text: 'App Name', sortable: false, value: 'app_name' },
  { text: 'Country', sortable: false, value: 'country' },
  { text: 'Application', sortable: false, value: 'application' },
  { text: 'Status', sortable: false, value: 'status' },
  { text: 'Updated', sortable: false, value: 'updated_at' },
  { sortable: false, value: 'edit' },
];

export default {
  components: { UpdatedDetails, TestRulesPatterns, RulesFilterSheet, UaDialog, RulesEditForm },
  extends: RulesList('ios'),
  data: () => ({
    headers,
    uaDialog: {
      show: false,
      matchId: 0,
    },
    testDialog: { show: false },
  }),
  methods: {
    openUAForm(id) {
      this.uaDialog.matchId = id;
      this.uaDialog.show = true;
    },
  },
};
</script>
